/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Set to 'RANGE' when this entry is a free interval of an open-range slot (book an arbitrary sub-window; priced per duration). Absent for fixed SINGLE/GROUP time slots.
 */
export enum AvailabilitySlotKind {
  RANGE = 'RANGE'
}
